import './bootstrap';
import Swiper from 'swiper/bundle';
import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';


// import Swiper styles
import 'swiper/css/bundle';
import 'photoswipe/style.css';

import.meta.glob(['../assets/**']);

window.imagesLoaded = imagesLoaded;
window.Swiper = Swiper;
window.PhotoSwipeLightbox = PhotoSwipeLightbox;
window.PhotoSwipe = PhotoSwipe;
window.Masonry = Masonry;
